import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CurrentUserFeatureService {
    private _router = inject(Router);

    goToProfile() {
        this._router.navigate(['/', 'me', 'profile']);
    }

    goToSettings() {
        this._router.navigate(['/', 'me', 'settings']);
    }
}
